import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AuditService } from 'app/audit/services/audit.service';
import { AuditTypeModel } from 'app/audit/models/audit-type.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Result } from 'app/core/models/result';
import { CompanyService } from 'app/company/services/company.service';

@Component({
    selector: 'app-company-audit-type-add',
    templateUrl: './company-audit-type-add.component.html',
    styleUrls: ['./company-audit-type-add.component.css']
})
export class CompanyAuditTypeAddComponent implements OnInit {
    errors: string[];
    auditTypes: AuditTypeModel[];
    addCompanyAuditTypeFrom: FormGroup;
    submitAttempt: boolean = false;
    @Input() companyId: string;
    @Output() companyAuditTypeAdded: EventEmitter<string> = new EventEmitter<string>();

    constructor(
        private companyService: CompanyService,
        private auditService: AuditService,
        private fb: FormBuilder,
        private modalService: NgbModal
    ) { }

    ngOnInit() {
        this.getAuditTypes();

        this.addCompanyAuditTypeFrom = this.fb.group({
            companyId: [this.companyId],
            auditTypeId: ['', Validators.required]
        });
    }

    getAuditTypes(): void {
        this.auditService.getAuditTypes().subscribe(result => {
            this.auditTypes = result;
        });
    }

    addAuditTypeToCompany(): void {
        this.submitAttempt = true;
        if (this.addCompanyAuditTypeFrom.valid) {
            const formValue = this.addCompanyAuditTypeFrom.value;
            formValue.companyId = this.companyId;

            this.companyService.createCompanyAuditType(formValue).subscribe(
                result => {
                    this.companyAuditTypeAdded.emit(result);
                    this.addCompanyAuditTypeFrom.reset();
                    this.submitAttempt = false;
                    this.modalService.dismissAll('saved');
                },
                error => {
                    this.errors = (<Result>error).errorList;
                    this.submitAttempt = false;
                }
            );
        }
    }

    openAddAuditType(content) {
        this.modalService.open(content);
    }
}
